export default (siteName) => [
    {
        path: 'loan-management',
        name: 'loan-management',
        component: () => import('../../components/dashboard/Finance/LoanManagement/IndexPage.vue'),
        meta: {
            title: `借款管理${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'loan-management/:sno/detail',
        name: 'loan-management-detail',
        component: () => import('../../components/dashboard/Finance/LoanManagement/LoanDetailPage.vue'),
        meta: {
            title: `借款合約明細${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'loan-management/add',
        name: 'loan-management-add',
        component: () => import('../../components/dashboard/Finance/LoanManagement/LoanAddPage.vue'),
        meta: {
            title: `新增借款管理${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'loan-management/:sno/edit',
        name: 'loan-management-edit',
        component: () => import('../../components/dashboard/Finance/LoanManagement/LoanAddPage.vue'),
        meta: {
            title: `修改借款管理${siteName}`,
            activeMenu: 'finance',
        },
    },
];
